import * as React from 'react';

import { scale110 } from '@xing-com/tokens';

import { SkeletonCircle } from '../';
import type { SkeletonRadioButtonProps } from '../';

export const SkeletonRadioButton = React.forwardRef<
  HTMLDivElement,
  SkeletonRadioButtonProps
>(({ className, ...props }, forwardedRef): JSX.Element => {
  return (
    <SkeletonCircle
      aria-hidden="true"
      className={className}
      data-xds="SkeletonRadioButton"
      ref={forwardedRef}
      role="presentation"
      size={scale110}
      {...props}
    />
  );
});

SkeletonRadioButton.displayName = 'SkeletonRadioButton';
